import React from 'react';
import Image from 'next/image';

import FindBundleForm from './FindBundleForm';

import styles from './styles.module.scss';

const FindBundle = ({ data }) => {
  return (
    <div
      className={'wrapper section'}
      itemScope
      itemType='http://schema.org/ItemList'
    >
      <div className={styles.container}>
        <FindBundleForm data={data} />
        <div className={styles.image}>
          <Image
            src={data?.image}
            alt='bakcell'
            title='bakcell'
            loading='lazy'
            layout='fill'
          />
        </div>
      </div>
    </div>
  );
};

export default FindBundle;
